"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Joins together the text values contained in a PortableText object.
 *
 * @param {Array} blocks - Array of PortableText block objects to join.
 *
 * @returns {string} - The string contents of the PortableText.
 */
var portableTextToPlain = function portableTextToPlain() {
  var blocks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _lodash["default"])(blocks).map(function (block) {
    // if it's not a text block with children, return nothing
    // eslint-disable-next-line no-underscore-dangle
    if ((block === null || block === void 0 ? void 0 : block._type) !== 'block' || !(block !== null && block !== void 0 && block.children)) {
      return '';
    }
    // loop through the children spans, and join the
    // text strings
    return (0, _lodash["default"])(block === null || block === void 0 ? void 0 : block.children).map('text').join('');
  }).filter(function (text) {
    return !(0, _fp.isEmpty)(text);
  }).join('\n');
};
var _default = exports["default"] = portableTextToPlain;
module.exports = exports.default;